module.exports = __webpack_public_path__ + "static/media-3644969b048527fbc6740f4fda649ff7.jpg";